<template>
    <div class="followup">
        <SubHeader />
        <div class="followup-content">
            <router-view />
        </div>
        <Notification />
    </div>
</template>

<script>
import Notification from '@/components/Notification.vue';
import SubHeader from './SubHeader.vue';

export default {
    name: 'Followup',
    components: {
        SubHeader,
        Notification
    },
    mounted() {
        this.$store.dispatch('setMenuActive', '查預約');
    }
};
</script>

<style lang="scss">
.followup {
    .input-width {
        max-width: 350px;
    }
    .label {
        color: #666666;
        font-size: 18px;
    }
    .followup-form,
    .result {
        max-width: 540px;
    }
    .mt-40 {
        margin-top: 40px;
    }
    @media (max-width: 576px) {
        .followup-content {
            padding: 1rem;
        }
    }
}
</style>
